import { useLiveQuery } from 'dexie-react-hooks'
import { useMemo } from 'react'
import type { User } from '../api/types'
import { db } from '../db/db'
import type { UserMap } from '../lib/channels'

const EMPTY: User[] = []

/** All locally known users as a Map (live). */
export function useUserMap(): UserMap {
  const users = useLiveQuery(() => db.users.toArray(), [], EMPTY)
  return useMemo(() => new Map(users.map((u) => [u.id, u])), [users])
}
